exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.auto-complete-container{border:1px solid #b0c4de;background-color:#ccc;white-space:nowrap}div.auto-complete-absolute-container{position:absolute;z-index:10000}div.auto-complete-container ul.auto-complete-results{overflow-x:hidden;overflow-y:auto;margin:0;padding:0}div.auto-complete-container ul.auto-complete-results li.auto-complete-item{list-style-type:none;padding:8px 5px;background-color:#efefef;cursor:pointer;font-weight:700}div.auto-complete-container ul.auto-complete-results li:not(:first-child){margin-top:1px}div.auto-complete-container ul.auto-complete-results li.auto-complete-item-selected,div.auto-complete-container ul.auto-complete-results li.auto-complete-item:hover{background-color:#69f;color:#fff}div.auto-complete-container table.auto-complete{width:100%;border-collapse:collapse;margin:0;border-width:0;border-style:none}div.auto-complete-container table.auto-complete tr{white-space:nowrap;text-align:left}div.auto-complete-container table.auto-complete tbody tr>td{padding:0;background-color:transparent;border-width:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules?sourceMap!./~/angular-auto-complete/angular-auto-complete.css
// module id = 692
// module chunks = 0